import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService, Response_Login, Response_Login_Service, UserInfo } from 'src/app/services/login/login.service';
import { selectedItem } from '../utils/select/select.component';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  toastConfig : {title: string, class: string} | undefined;

  loginForm : FormGroup | undefined;

  username: string = '';
  password: string = '';

  listLang: {key: string, value: string}[] = [
    {key: 'it', value: 'Italiano'},
    {key: 'en', value: 'English'}
  ]
  selectedLang : string | null = "";
  passwordFieldType : string = "password";
  hidePw: boolean = true;
  private e_loginUrl: string = AppConfig.settings.apiServer.loginUrl;
  private e_redirectUrl: string = AppConfig.settings.apiServer.redirectUrl;
  private e_enableRedirectUri: boolean = AppConfig.settings.apiServer.enableRedirectUri;

  onSelectChange(list: string[]){
    // console.log(list);
  }

  constructor(
    private route: ActivatedRoute, 
    public translate: TranslateService, 
    private logService : LoginService, 
    public router: Router) {

    this.translate.setDefaultLang(localStorage.getItem('language_dm7') || 'it');
    this.selectedLang = localStorage.getItem('language_dm7') || 'it';

  }

  changeLanguage(language: selectedItem){
    this.translate.setDefaultLang(language.key);
    localStorage.setItem('language_dm7', this.translate.getDefaultLang());
  }

  /**
   * Login
   */
  async login() {
    localStorage.removeItem('access_token_einvoice');
    localStorage.removeItem('einvuser');
    localStorage.removeItem('userId_einvoice');
    localStorage.removeItem('einvoice_modify_doc');
    localStorage.removeItem('email_einvoice');
    localStorage.setItem('language_dm7', this.translate.getDefaultLang());
    let response : Response_Login_Service = await this.logService.doPostLogin(this.username, this.password);
    if (response.success) {
      let usrInfo : Response_Login = response.data as Response_Login;
      /* this.logService.resetUserInfo(); */
      localStorage.setItem('access_token_einvoice', usrInfo!=undefined? usrInfo.access_token : '');
      localStorage.setItem('einvuser', JSON.stringify(usrInfo));
      if (usrInfo.change_password) {
        localStorage.setItem('userId_einvoice', "" + usrInfo.user_id);
        localStorage.setItem('email_einvoice', usrInfo.email);
        this.router.navigate(['/changepwd']);
      } else {
        this.router.navigate(['/OptimaSmart']);
      }
    } else {
      this.toastConfig = {class:'error', title: response.msg};
    }
  }

  registrazione() {
    this.router.navigate(['/Register']);
  }

  changeVisibility() {
    this.hidePw= !this.hidePw;
    if(this.hidePw) {
      this.passwordFieldType='password'
    } else {
      this.passwordFieldType='text'
    }
  }
}
